import Icon from '~/components/icon/index.js';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head.js';

const InformationPageHeaderWrapper = ({ iconType, mainTitle, subTitle }) => {
	return (
		<HeadWrapper>
			<Icon type={iconType} />
			<MainTitle dataAt="section-main-title-general-global-overlay">{mainTitle}</MainTitle>
			<SubTitle dataAt="section-sub-title-header-general-global-overlay">{subTitle}</SubTitle>
		</HeadWrapper>
	);
};

export default InformationPageHeaderWrapper;
